import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef, OnDestroy, OnChanges } from '@angular/core';
import { PlantServiceService } from '../../../../../services/dashboard/solar/plant-service.service';
import { Chart, StockChart } from 'angular-highcharts';
import { Router, RouterLink, ActivatedRoute, ParamMap } from '@angular/router';
import * as moment from 'moment';
import { DatePipe, DecimalPipe } from '@angular/common';
import { FormControl } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { SolarLongTermTrendParameterModel } from '../../../../../models/solar-configuration.model';
import { Moment } from 'moment';
import { MatDatepicker } from '@angular/material';
// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'YYYY-MM-DD',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-solar-long-term-trend',
  templateUrl: './solar-long-term-trend.component.html',
  styleUrls: ['./solar-long-term-trend.component.scss'],
  providers: [
    // The locale would typically be provided on the root module of your application. We do it at
    // the component level here, due to limitations of our example generation script.
    // {provide: MAT_DATE_LOCALE, useValue: 'hi-IN'},
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class SolarLongTermTrendComponent implements OnInit, AfterViewInit, OnChanges {
  siteId: string;
 // Baseon Business siteId = (commonService.isNotSiteSpecific ? siteService.getSiteID() : commonService.siteId);
 yieldDuration = 'Hourly';
 co2Factor = 0;
 performanceRatioOneday = 0;
 LatestPower = 0;
 LatestIrradiance = 0;
 PlantStartTime = null;
 PlantStopTime = null;
 powerIrradianceDate = moment().format('YYYY-MM-DD');
 shifts: any;
 timebaseArr = [
    {value: 'Y', viewValue: 'Yearly'},
    {value: 'M', viewValue: 'Monthly'},
    {value: 'Q', viewValue: 'Quarterly'},
    {value: 'W', viewValue: 'Weekly'},
    {value: 'D', viewValue: 'Daily'}
  ];
  timebase = 'D';
  columnchart: Chart;
  startDate = new FormControl(moment());
  endDate = new FormControl(moment());
  enableShiftwise = false;
  startView = 'month';
  minView = 'day';
  hourWiseDataRequired = false;
  max = new Date();
  constructor(private activeRoute: ActivatedRoute, private router: Router,
    private datePipe: DatePipe, private plantService: PlantServiceService,
    private cd: ChangeDetectorRef) {
    this.siteId = this.activeRoute.snapshot.queryParams['siteId'];
    this.onTimeBaseChange();
   }

  ngOnInit() {
    this.plantService.getShiftsBySiteId(this.siteId).subscribe(
      data => {
        this.shifts = data;
      }
     );
  }
  chosenStartDate_YearHandler(normalizedYear: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.startDate.value;
    ctrlValue.year(normalizedYear.year());
    this.startDate.setValue(moment(ctrlValue).startOf('year'));
    // this.startDate.setValue(ctrlValue);
    datepicker.close();
  }
  chosenStartDate_MonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.startDate.value;
    ctrlValue.month(normalizedMonth.month());
    this.startDate.setValue(moment(ctrlValue).startOf('month'));
    datepicker.close();
  }
  chosenEndDate_YearHandler(normalizedYear: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.endDate.value;
    ctrlValue.year(normalizedYear.year());
    this.endDate.setValue(moment(ctrlValue).startOf('year'));
    // this.endDate.setValue(ctrlValue);
    datepicker.close();
  }
  chosenEndDate_MonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.endDate.value;
    ctrlValue.month(normalizedMonth.month());
    this.endDate.setValue(moment(ctrlValue).startOf('month'));
    datepicker.close();
  }
  ngOnChanges() {
  }
  ngAfterViewInit() {
  }
  onTimeBaseChange() {
    switch (this.timebase) {
      case 'Y': {
        this.startView = 'multi-year';
        this.minView = 'year';
        this.startDate = new FormControl(moment().startOf('year'));
        this.hourWiseDataRequired = false;
        break;
        }
        case 'M': {
              this.startView = 'year';
              this.minView = 'month';
              this.startDate = new FormControl(moment().startOf('month'));
              this.hourWiseDataRequired = false;
              break;
              }
        case 'Q': {
        this.startView = 'year';
        this.minView = 'month';
        this.startDate = new FormControl(moment().startOf('year'));
        this.hourWiseDataRequired = false;
        break;
        }
        case 'W': {
          this.startView = 'month';
          this.minView = 'day';
          this.startDate = new FormControl(moment().startOf('month'));
          this.hourWiseDataRequired = false;
          break;
          }
        default: {
          this.startView = 'month';
          this.minView = 'day';
          this.startDate = new FormControl(moment().subtract(3, 'days'));
          this.hourWiseDataRequired = true;
          break;
        }
    }
    this.endDate = new FormControl(moment());
  }
  onGenerate() {
    this.getDataAndDrawEnergyTrendsChart();
  }
  onBack() {
    this.router.navigate(['site/solar-dashboard', 'plant-view'], { queryParams: { siteId: this.siteId, activedTab: 3 } });
  }
  transformDate(date: FormControl) {
    if (date.valid) {
      return this.datePipe.transform(date.value, 'yyyy-MM-dd');
    } else {
      return '';
    }
  }
  private getDataAndDrawEnergyTrendsChart() {
    const fromDate = this.transformDate(this.startDate);
    const toDate = this.transformDate(this.endDate);
    if (this.enableShiftwise) {
      const model = {siteId: this.siteId, startDate: fromDate, endDate: toDate, timebase: this.timebase};
       // tslint:disable-next-line:max-line-length
       this.plantService.getSolarLongTermTrendsBuildingWiseUrl(model).subscribe(data => {
         if (data.YieldTrendValues) {
          // const categories = [];
          // const result = new Map<string, any[]>();
          // data.YieldTrendValues.forEach(x => {
          //   categories.push(<any>x.xAxis);
          //   if (isObject(x.SolarAndEnergyValues) && !isNullOrUndefined(x.SolarAndEnergyValues)) {
          //     for (const [key, value] of Object.entries(x.SolarAndEnergyValues)) {
          //       if (result.has(key)) {
          //           const currentValues = result.get(key);
          //           result.set(key, currentValues.concat(value));
          //       } else {
          //            const newValue = [];
          //           result.set(key, newValue.concat(value));
          //       }
          //     }
          //   }
          //   });
          //  const series = Array.from(result).map(x => ({name: x[0], data: x[1]}));
          //  this.onInitBuildingWiseChart(categories, series);
          const series = [];
          const categories = [];
          data.YieldTrendValues.forEach((v, i) => {
            categories.push(<any>v.xAxis);
            const entries = Object.entries(v.SolarAndEnergyValues);
            if (entries.length > 0) {
              let xObject: {x: number, y: any} = {x: 0, y: null};
              xObject.x = i;
              let dataPaser = {data: [], name: ''};
              for (const [key, value] of entries) {
               dataPaser = {data: [], name: ''}; // Reset value
                xObject.y = value;
                dataPaser.name = key;
                const index = series.findIndex(se => se.name === key);
                if (index === -1) {
                  dataPaser.data.push(xObject);
                  series.push(dataPaser);
                } else {
                  const current = series[index];
                  current.data.push(xObject);
                  series[index] = current;
                }
                xObject = {x: i, y: null}; // Reset value
              }
            } else {
            const xObject: {x: number, y: any} = {x: 0, y: null};
            xObject.x = i;
            const dataPaser = {data: [], name: ''};
              xObject.y = null;
              dataPaser.data.push(xObject);
              series.push(dataPaser);
            }
          });
           // const series = Array.from(result).map(x => ({name: x[0], data: x[1]}));
            this.onInitBuildingWiseChart(categories, series);
         }
      });
    } else {
      const model = new SolarLongTermTrendParameterModel(this.siteId, fromDate, toDate, this.timebase, this.enableShiftwise, []);
      this.plantService.getSolarEnergyTrendsData(model).subscribe(data => {
       this.drawEnergyTrendsChart(data, this.enableShiftwise);
   });
    }
  }
  private drawEnergyTrendsChart(data: any, enableShiftwise: boolean) {
    const option =  this.getChartOption(enableShiftwise);
    const categories = [];
    const series = [];
    if (!enableShiftwise) {
    const shiftcategories = [];
    // const ecOfLoadsOnDate = data.ecOfLoadsOnDate;
    const ecOfLoadsOnDate = data.YieldTrendValues;
    const allShiftDataArrays = []; // this.shifts.map(x=> ({ x.shiftId, x.shiftName });
    for (let sn = 0; sn < this.shifts.length; sn++) {
      const shiftDataArray = [this.shifts[sn].shiftId, this.shifts[sn].shiftName];
      allShiftDataArrays.push(shiftDataArray);
    }
    const allDayDataArrays = [];
    for (let sm = 0; sm < ecOfLoadsOnDate.length; sm++) {
      const dateArray = [ecOfLoadsOnDate[sm].xAxis];
      allDayDataArrays.push(dateArray);
    }
    for (let i = 0; i < ecOfLoadsOnDate.length; i++) {
      const date = ecOfLoadsOnDate[i].xAxis;
      if (enableShiftwise === true) {
        shiftcategories.push(date);
        for (let s = 0; s < this.shifts.length; s++) {
          const dataArr = [];
          let sumEC = 0;
              let found = false;
              for (let k = 0; k < ecOfLoadsOnDate[i].valueArr.length; k++) {
                const item = ecOfLoadsOnDate[i].valueArr[k];
                  sumEC += item.sum;
                  found = true;
                  break;
                }
            dataArr.push(sumEC);
            for (let ar = 0; ar < allShiftDataArrays.length; ar++) {
              if (this.shifts[s].shiftId === allShiftDataArrays[ar][0]) {
                allShiftDataArrays[ar].push(sumEC);
              }
            }
          }
        option.xAxis[0].categories = shiftcategories;
      } else {
        const dataArr = [];
        categories.push(date);
        let sumEC1 = 0;
        let found = false;
        for (let k = 0; k < ecOfLoadsOnDate[i].valueArr.length; k++) {
          const item = ecOfLoadsOnDate[i].valueArr[k];
          sumEC1 += item.sum;
          found = true;
          break;
        }
        dataArr.push(sumEC1);
        for (let ard = 0; ard < allDayDataArrays.length; ard++) {
          if (date === allDayDataArrays[ard][0]) {
            allDayDataArrays[ard].push(sumEC1);
          }
        }
        option.xAxis[0].categories = categories;

      }
    }
    if (enableShiftwise === true) {
      for (let sr = 0; sr < allShiftDataArrays.length; sr++) {
        const name = allShiftDataArrays[sr].splice(0, 2)[1];
        series.push({
          name : name,
          data : allShiftDataArrays[sr],
          showInLegend : true
        });
      }
    } else {
      // for (let sre = 0; sre < allDayDataArrays.length; sre++) {
      //   const srname = allDayDataArrays[sre].splice(0, 1)[0];
      // }
      series.push({
        // 	name : srname,
        data : allDayDataArrays,
        showInLegend : false
      });
    }
    option.series = series;
    this.columnchart = new Chart(<any>option);
  } else {
      // const ecOfLoadsOnDate = data.ecOfLoadsOnDate;
      // for (let k = 0; k < this.buildingsLoadsMeters.length; k++) {
      //   this.buildingsLoadsMeters[k].solarEnergy = [];
      //   for (let i = 0; i < ecOfLoadsOnDate.length; i++) {
      //       this.buildingsLoadsMeters[k].solarEnergy.push(0);
      //     }
      //   }
      //   for (let i = 0; i < ecOfLoadsOnDate.length; i++) {
      //     categories.push(ecOfLoadsOnDate[i].xAxis);
      //     for (let j = 0; j < ecOfLoadsOnDate[i].valueArr.length; j++) {
      //       const meterId = ecOfLoadsOnDate[i].valueArr[j].meterid;
      //       if (meterId !== null && meterId !== undefined) {
      //         for (let k = 0; k < this.buildingsLoadsMeters.length; k++) {
      //           if (this.buildingsLoadsMeters[k].meterIds.indexOf(meterId.toString()) !== -1) {
      //             this.buildingsLoadsMeters[k].solarEnergy[i] += ecOfLoadsOnDate[i].valueArr[j].sum;
      //           }
      //         }
      //       }
      //     }
      //   }
      //   option.xAxis[0].categories = categories;
      //   const chartSeries = [];
      //   for (let k = 0; k < this.buildingsLoadsMeters.length; k++) {
      //     chartSeries.push({data: this.buildingsLoadsMeters[k].solarEnergy, name: this.buildingsLoadsMeters[k].title});
      //   }
      //   option.series = chartSeries;
        const entries = Object.entries(data);
        option.series = Array.from(entries).map(([key, value]) => ({name: key, data: value}));
        this.columnchart = new Chart(<any>option);
  }
  }
  private getChartOption(isStacking: boolean) {
    const option = {
      chart : {
        type: 'column',
        height : 585,
      },
      credits : {
        enabled : false
      },
      title : {
        text : 'Energy Generation Trends'
      },
      xAxis : [{
        categories : [],
        crosshair : true
      }],
      yAxis : {
        title: {
          text: 'Total Energy Generation (kWh->)'
        },
        reversedStacks : false
      },
      plotOptions: {
        column: {
          stacking: (isStacking === true ? 'normal' : ''),
          dataLabels: {
            enabled: true
        }
        },
      },
      series : [{}],
      legend: {},
      tooltip: {}
    };
    if (isStacking) {
      option.legend = {
        title: {
          text : ':: Drag me',
        },
       layout : 'vertical',
       align : 'left',
       x : 120,
       verticalAlign : 'top',
       y : 100,
       floating : true,
       draggable: true,
       enabled: true,
        backgroundColor: '#FFFFFF'
     };
     option.tooltip = {
      headerFormat: '<b>{point.x}</b><br/>',
      // tslint:disable-next-line:max-line-length
      pointFormat: `<span style="color:{series.color}">{series.name} : <b>{point.y}</b> </span>
      <br/> <span>Total: <b> {point.stackTotal} </b></span>`,
      // footerFormat: '<span>Total: <b> {point.stackTotal} </b></span>',
      // shared: true,
      // useHTML: true
      };
    } else {
      option.tooltip = {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
        '<td style="padding:0"><b>{point.y:.3f} kWh</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true
      };
    }
    return option;
  }
  onInitBuildingWiseChart(categories: any, series: any) {
    // let subTitleText = '';
    let xAxis: any;
    xAxis = {
      categories : categories,
    };
    // if (this.timebase === 'D') {
    //   xAxis = {
    //     type : 'datetime',
    //     labels : {
    //       formatter : function() {
    //         return Highcharts$.dateFormat('%Y-%m-%d',
    //             this.value);
    //       }
    //     },
    //     crosshair : true
    //   };
    // } else {
    //   xAxis = {
    //     categories : categories,
    //   };
    // }
    const chartOption = {
      chart : {
        type: 'column',
        height : 500,
      },
      credits : {
        enabled : false
      },
      title : {
        text : 'Energy Yield Trend BuildingWise',
        style : {
          fontSize : '14px'
        }
      },
      // subtitle : {
      //   text : subTitleText
      // },
      xAxis : xAxis,
      yAxis : {
        title: {
           text: 'Total Energy Generation (kWh->)'
          },
          reversedStacks : false
        },
        tooltip : {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.3f} kWh</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        legend : {
          layout : 'vertical',
          align : 'left',
           x : 40,
          verticalAlign : 'top',
           y : 60,
          // title: {
          //   text: ':: Drag me'
          // },
          floating : true,
          draggable: true,
          backgroundColor : '#FFFFFF'
        },
        plotOptions: {
          column: {
            stacking: 'normal'
          },
        },
        series : series };
      this.columnchart = new Chart(<any>chartOption);
  }
}
